<template>
  <v-row justify="center">
    <v-dialog
      v-model="modal"
      persistent
      max-width="350"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{title}}
        </v-card-title>
        <v-card-text>
          {{body}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            v-if="primaryBtnName" 
            @click="invokeMethod(onPrimaryBtnClicked)"
          >
            {{primaryBtnName}}
          </v-btn>
          <v-btn
            color="secondary"
            text
            v-if="secondaryBtnName"
            @click="modal = false"
          >
            {{secondaryBtnName}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

  export default {
    components: {
    },
    data() {
      return {
        modal: false,
        title: "",
        body: "",
        primaryBtnName: "",
        onPrimaryBtnClicked: "",
        secondaryBtnName: "",
        refreshSessionAction: "onRefreshSessionClicked",
        onModalCloseClicked: ""
      }
    },
    mounted() {
      var self = this
      this.$root.$on('popupMessage', function(cmd) {
        switch (cmd) {
          case "sessionExpired":
              self.sessionExpiredMessage()
              break
          default:
              // console.log("Command is not found.")
              break
        }
          
      })
    },
    methods: {
      invokeMethod(methodName) {
          this[methodName]();
      },
      sessionExpiredMessage() {
        // console.log("refreshSession")
        this.modal = true
        this.title = "Your session has expired."
        this.body = "Please click the button below to relogin."
        this.primaryBtnName = "Relogin"
        this.onPrimaryBtnClicked = "onReloginClicked"
        this.onModalCloseClicked = "doNothing"
      },
      onReloginClicked() {
        this.$keycloak.logout()
      },
      doNothing() {
        return
      }
    },
    computed: {

    }

  };
</script>